import { Field, Formik } from "formik";
import { toast } from "react-toastify";
import { InvoiceSheme } from "../../../validations/InvoiceSheme";
import { PassengerShema } from "../../../validations/PassengerShema";
import { SavePassengerInformation } from "../../api";
import PhoneInputW from "../../Reservation/PhoneInput";
import Input from "../Payment/Input";
import GuestInformationSuccessfully from "./GuestInformationSuccessfully";
import { useTranslation } from "../../../context/TranslationContext";

const GuestInformation = ({
  activeTabs,
  page,
  setPage,
  formData,
  setFormData,
  validTabs,
  setValidTabs,
  passenger,
  step,
  setStep,
  passengerInformationData,
  loginData,
  id,
  setOpen,
  list,
  dateDay,
  dateMonth,
  dateYear,
}) => {
  const handleSubmit = (data) => {
    setStep(1);
  };

  const Save = (passengerData, actions) => {
    SavePassengerInformation(loginData.Token, id, {
      invoice: passengerData,
      passenger: formData,
    })
      .then((e) => {
        if (e.data.error) {
          toast.error(e.data.error);
        } else {
          toast.success(e.data.success);
          setStep(2);
          list();
        }
      })
      .finally((e) => {
        actions.setSubmitting(false);
      });
  };
  const {
    GuestInformationTitle,
    GuestInformationName,
    GuestInformationGender,
    GuestInformationGenderMale,
    GuestInformationGenderFemale,
    GuestInformationBirthDate,
    GuestInformationBirthPlace,
    GuestInformationTc,
    GuestInformationNotTurkeyPeople,
    goBack,
    save,
    GuestInformationPassaport,
    GuestInformationInvoiceType,
    GuestInformationInvoiceTypeOption1,
    GuestInformationInvoiceTypeOption2,
    GuestInformationInvoiceTypeOption1Name,
    GuestInformationInvoiceTypeOption2Name,
    GuestInformationInvoiceTaxOffice,
    GuestInformationInvoiceTaxNumber,
    address,
    email,
    phone,
  } = useTranslation();

  return (
    <div className="flex flex-col">
      <div className="mb-[54px] w-full">
        {step == 0 && (
          <div className="flex xmd:flex-nowrap flex-wrap  xmd:gap-x-6 gap-y-10">
            {activeTabs.map((i, k) => (
              <Formik
                key={k}
                initialValues={{
                  name: "",
                  gender: "",
                  day: "",
                  month: "",
                  year: "",
                  placeOfBirth: "",
                  tc: "",
                  isTurkish: false,
                }}
                validationSchema={PassengerShema}
                onSubmit={(values, actions) => {
                  const old = [...formData];
                  if (old[i]) {
                    old[i] = values;
                    setFormData(old);
                  } else setFormData([...formData, values]);

                  setValidTabs([...validTabs, i]);
                  actions.setSubmitting(false);

                  if (page != passenger) {
                    actions.resetForm();
                    setPage(page + 1);
                  } else {
                    handleSubmit(formData);
                  }

                  if (formData[i + 1]) actions.setValues(formData[i + 1]);
                }}
              >
                {(props) => (
                  <form
                    className="flex flex-col w-full"
                    onSubmit={props.handleSubmit}
                  >
                    <span className="font-semibold xmd:text-[23px] text-[17px] leading-8 text-dark mb-6">
                      {GuestInformationTitle.replace("{no}", i + 1)}
                    </span>
                    <div className="relative z-0 mb-[30px] w-full group">
                      <Input
                        name="name"
                        placeholder=" "
                        label={GuestInformationName}
                      />
                    </div>
                    <div className="flex items-center mb-7">
                      <span className="text-[#A2B2B8] text-13 font-medium leading-4 mr-[66px]">
                        {GuestInformationGender}
                      </span>
                      <div className="flex items-center mr-6 justify-center content-center gap-x-3">
                        <label className="text-13 font-medium text-gray-900 flex items-center gap-x-1">
                          <Field type="radio" name="gender" value="0" />
                          {GuestInformationGenderFemale}
                        </label>
                        <label className="text-13 font-medium text-gray-900 flex items-center gap-x-1">
                          <Field type="radio" name="gender" value="1" />
                          {GuestInformationGenderMale}
                        </label>
                      </div>
                    </div>
                    <div className="flex ml:flex-nowrap flex-wrap items-center mb-2">
                      <span className="text-[#A2B2B8] text-13 font-medium leading-4 mr-9 whitespace-nowrap ml:mb-0 mb-2">
                        {GuestInformationBirthDate}
                      </span>
                      <div className="flex items-center gap-x-2">
                        <div className="relative z-0 xl:w-[145px] w-full group ">
                          <Input
                            name="day"
                            placeholder="- -"
                            label={dateDay}
                            mask="__"
                            replacement={{ _: /\d/ }}
                          />
                        </div>
                        <div className="relative z-0 xl:w-[145px] w-full group">
                          <Input
                            name="month"
                            placeholder="- -"
                            label={dateMonth}
                            mask="__"
                            replacement={{ _: /\d/ }}
                          />
                        </div>
                        <div className="relative z-0 xl:w-[145px] w-full group">
                          <Input
                            name="year"
                            placeholder="- - - -"
                            label={dateYear}
                            mask="____"
                            replacement={{ _: /\d/ }}
                          />
                        </div>
                      </div>
                    </div>
                    <div className="relative z-0 mb-2 w-full group">
                      <Input
                        name="placeOfBirth"
                        placeholder=" "
                        label={GuestInformationBirthPlace}
                      />
                    </div>
                    <div className="relative z-0 mb-2 w-full ">
                      <Input
                        name="tc"
                        placeholder=" "
                        label={
                          props.values.isTurkish
                            ? GuestInformationPassaport
                            : GuestInformationTc
                        }
                      />
                    </div>
                    <label className="text-13 font-medium text-gray-900 flex items-center gap-x-1">
                      <Field type="checkbox" name="isTurkish" />
                      {GuestInformationNotTurkeyPeople}
                    </label>
                    <div className="flex items-center justify-end  gap-x-2 ">
                      {page > 1 && (
                        <button
                          type="button"
                          onClick={() => {
                            setPage(page - 1);
                            props.setValues(formData[i - 1]);
                          }}
                          className="py-[10px] px-[17px] rounded border border-[#b2c2cb] text-[#B2C2CB] text-[12px] font-bold"
                        >
                          {goBack}
                        </button>
                      )}
                      <button
                        type="submit"
                        disabled={
                          props.isSubmitting || !props.isValid || !props.dirty
                        }
                        className="py-[10px] px-[17px] rounded border bg-primary text-white text-sm font-bold disabled:opacity-60 disabled:cursor-not-allowed"
                      >
                        {save}
                      </button>
                    </div>
                  </form>
                )}
              </Formik>
            ))}
          </div>
        )}
        {step == 1 && (
          <>
            <div className="flex xmd:flex-nowrap flex-wrap  xmd:gap-x-6 gap-y-10">
              <Formik
                initialValues={{
                  faturatipi: "1",
                  isim: passengerInformationData.reservation.musteri,
                  tcno: passengerInformationData.reservation.tc,
                  email: passengerInformationData.reservation.email,
                  telefon: passengerInformationData.reservation.telefon,
                  mesaj: "",
                  vergidairesi: "",
                  telefonIsValid: false,
                }}
                validationSchema={InvoiceSheme}
                onSubmit={(values, actions) => {
                  Save(values, actions);
                }}
              >
                {(props) => (
                  <form
                    className="flex flex-wrap w-full"
                    onSubmit={props.handleSubmit}
                  >
                    <div className="flex items-center mb-7 mt-4 w-full p-1">
                      <span className="text-[#A2B2B8] text-13 font-medium leading-4 mr-[66px]">
                        {GuestInformationInvoiceType}
                      </span>
                      <div className="flex items-center mr-6 justify-center content-center gap-x-3">
                        <label className="text-13 font-medium text-gray-900 flex items-center gap-x-1">
                          <Field type="radio" name="faturatipi" value="1" />
                          {GuestInformationInvoiceTypeOption1}
                        </label>
                        <label className="text-13 font-medium text-gray-900 flex items-center gap-x-1">
                          <Field type="radio" name="faturatipi" value="2" />
                          {GuestInformationInvoiceTypeOption2}
                        </label>
                      </div>
                    </div>
                    <div className="relative z-0 w-full sm:w-1/2 group  p-1">
                      <Input
                        name="isim"
                        placeholder=" "
                        label={
                          props.values.faturatipi == "1"
                            ? GuestInformationInvoiceTypeOption1Name
                            : GuestInformationInvoiceTypeOption2Name
                        }
                      />
                    </div>
                    <div
                      className={
                        "relative z-0 w-full sm:w-1/2 group p-1 " +
                        (props.values.faturatipi == "1" ? "hidden" : "")
                      }
                    >
                      <Input
                        name="vergidairesi"
                        placeholder=" "
                        label={GuestInformationInvoiceTaxOffice}
                      />
                    </div>
                    <div className="relative z-0 w-full sm:w-1/2 group  p-1">
                      <Input
                        name="tcno"
                        placeholder=" "
                        label={
                          props.values.faturatipi == "1"
                            ? GuestInformationTc
                            : GuestInformationInvoiceTaxNumber
                        }
                      />
                    </div>
                    <div className="relative z-0 w-full sm:w-1/2 group  p-1">
                      <Input name="email" placeholder=" " label={email} />
                    </div>
                    <div className="relative z-0 w-full sm:w-1/2 group min-h-[70px] p-1">
                      <PhoneInputW
                        name="telefon"
                        validname="telefonIsValid"
                        label={phone}
                        mode={"simple"}
                        isrequired="required"
                      ></PhoneInputW>
                    </div>
                    <div className="relative z-0 w-full sm:w-1/2 group  p-1">
                      <Input name="adres" placeholder=" " label={address} />
                    </div>
                    <div className="flex items-center justify-end  gap-x-2 w-full">
                      <button
                        type="submit"
                        disabled={
                          props.isSubmitting || !props.isValid || !props.dirty
                        }
                        className="py-[10px] px-[17px] rounded border bg-primary text-white text-sm font-bold disabled:opacity-60 disabled:cursor-not-allowed"
                      >
                        {save}
                      </button>
                    </div>
                  </form>
                )}
              </Formik>
            </div>
          </>
        )}
        {step == 2 && <GuestInformationSuccessfully setOpen={setOpen} />}
      </div>
    </div>
  );
};

export default GuestInformation;
